var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImageUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_457",
    "data-name": "Group 457",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 111 92.673",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_246",
    "data-name": "Path 246",
    d: "M111,2.6V78.675h-4.15a11.764,11.764,0,0,0,.346-3.458,22.117,22.117,0,0,0-3.112-11.757V9.516H6.916v61.9h4.841L34.234,33.721,47.72,55.852l10.72-14.178L68.813,55.161A23.273,23.273,0,0,0,63.626,60l-5.187-6.916L47.028,67.955,34.234,47.207,20.056,70.721H59.131v.692a11.764,11.764,0,0,0-.346,3.458v3.458H0V2.6ZM98.9,26.114a12.1,12.1,0,1,1-24.206,0,12.252,12.252,0,0,1,12.1-12.1A12.489,12.489,0,0,1,98.9,26.114Zm-6.916,0A5.187,5.187,0,1,0,86.794,31.3,5.092,5.092,0,0,0,91.981,26.114Z",
    transform: "translate(0 -2.6)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_247",
    "data-name": "Path 247",
    d: "M42.206,34.544h6.916V41.46H42.206v6.916H35.29V41.46H28.374V34.544H35.29V27.628h6.916ZM58.8,38A20.4,20.4,0,1,1,38.4,17.6,20.439,20.439,0,0,1,58.8,38Zm-6.916,0A13.5,13.5,0,0,0,38.4,24.516,13.287,13.287,0,0,0,24.916,38,13.287,13.287,0,0,0,38.4,51.488,13.082,13.082,0,0,0,51.888,38Z",
    transform: "translate(44.243 34.269)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageUpload);
export default __webpack_public_path__ + "static/media/image-upload.45f2e980.svg";
export { ForwardRef as ReactComponent };